import api from "./axios";

// Client ID prefixes (e.g. "SCA-NR-"). List + next-id are available to anyone
// who can create clients; create/update/delete are admin-only.
export const listClientPrefixes = () => api.get("/client-id-prefixes");
export const nextClientId = (prefixId) =>
  api.get(`/client-id-prefixes/${prefixId}/next`);
export const createClientPrefix = (payload) =>
  api.post("/client-id-prefixes", payload);
export const updateClientPrefix = (id, payload) =>
  api.put(`/client-id-prefixes/${id}`, payload);
export const deleteClientPrefix = (id) =>
  api.delete(`/client-id-prefixes/${id}`);
